// src/services/jobService.ts
import api from '../Services/axiosConfig';
import { JobDetail, JobsState } from '../types/job';

interface JobData {
  title: string;
  description: string;
  additionalConsideration: string;
  location: string;
  deadline: string;
  linkedinPost: string;
  screeningQuestions: string[];
  FlyerJobDescriptions: string[];
  FlyerJobSpecifications: string[];
  emailContent: string;
}

interface FormData {
  jobId: string;
  jobTitle: string;
  jobDescription: string | string[];
  location: string;
  deadline: string;
  screeningQuestions: string[];
}

interface JD {
  id: string;
  title: string;
}

// Existing functions
export const fetchJobs = async (): Promise<JobsState> => {
  const response = await api.get('/jobs');
  const data = response.data;
  
  return {
    open: data.openJobs.map((job: { deadline: string; }) => ({
      ...job,
      deadline: job.deadline ? job.deadline.split('T')[0] : undefined
    })),
    inReview: data.inReviewJobs.map((job: { reviewStarted: any; }) => ({
      ...job,
      reviewStarted: job.reviewStarted || new Date().toLocaleString()
    })),
    closed: data.closedJobs.map((job: { closedDate: any; }) => ({
      ...job,
      closedDate: job.closedDate || new Date().toLocaleString()
    }))
  };
};

export const updateJobStatus = async (jobId: string, newStatus: string): Promise<void> => {
  try {
    await api.put(`/jobs/${jobId}/status`, { status: newStatus });
  } catch (error) {
    console.error('Failed to update job status:', error);
    throw error;
  }
};

export const getJobDetails = async (jobId: string) => {
  try {
    const response = await api.get(`/jobs/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch job details:', error);
    throw error;
  }
};

export const getJobApplications = async (jobId: string) => {
  try {
    const response = await api.get(`/jobs/${jobId}/applications`);
    console.log("the candidates", response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch job applications:', error);
    throw error;
  }
};

export const fetchJobDetails = async (jobId: string): Promise<JobDetail> => {
  const response = await api.get(`/api/jobs/${jobId}/details`);
  return response.data;
};

// New functions for PostNewJob component
export const fetchJDList = async (companyId: string) => {
  const response = await api.get(`/jobdescriptions/ListJDs/?companyId=${companyId}`);
  return response.data;
};

export const fetchJDContent = async (jdId: string) => {
  const response = await api.get(`/jobdescriptions/read/${jdId}`);
  return response.data.content;
};

export const createJob = async (jobData: JobData) => {
  const response = await api.post("/jobs", jobData);
  return response.data;
};

export const createApplicationForm = async (formData: FormData) => {
  const response = await api.post("jobs/forms/create", formData);
  return response.data;
};

export const generateFlyer = async (jobId: string, formLink: string) => {
  const response = await api.get(
    `/jobs/generate?jobId=${jobId}&formLink=${encodeURIComponent(formLink)}`,
    { responseType: "json" }
  );
  return response.data;
};